export function numericPosition(value) {
  if (value === null || value === undefined || value === "") return null;
  const position = Number(value);
  return Number.isFinite(position) ? position : null;
}

export function compareNullableNumbers(a, b) {
  const numberA = numericPosition(a);
  const numberB = numericPosition(b);
  if (numberA === null && numberB === null) return 0;
  if (numberA === null) return 1;
  if (numberB === null) return -1;
  return numberA - numberB;
}

export function rowKey(row) {
  return row.rowId != null ? row.rowId : row.dashboardRowId;
}

export function compareRowIds(a, b) {
  return String(rowKey(a) ?? "").localeCompare(String(rowKey(b) ?? ""), undefined, {
    numeric: true,
  });
}

export function compareSubRows(a, b) {
  return (
    compareNullableNumbers(a.subPosition, b.subPosition) ||
    compareNullableNumbers(a.position, b.position) ||
    compareRowIds(a, b)
  );
}
